import gql from 'graphql-tag';

import {
  SEND_MESSAGE_START,
  SEND_MESSAGE_SUCCESS,
  SEND_MESSAGE_ERROR,
} from '../../constants';

import AllThreadsQuery from './../../routes/viewMessage/AllThreadsQuery.graphql';

export function sendMessageAction(
  threadId,
  userType,
  content,
  threadType,
  startDate,
  endDate,
  reservationId,
  pickupAddress = {},
  returnAddress = {},
  pickupTime,
  returnTime,
) {
  return async (dispatch, getState, { client }) => {
    dispatch({
      type: SEND_MESSAGE_START,
    });

    try {
      let mutation = gql`
        mutation sendMessage(
          $threadId: Int!
          $reservationId: Int
          $content: String
          $eventName: String
          $startDate: String
          $endDate: String
          $pickupTime: String
          $returnTime: String
          $pickupCity: String
          $pickupState: String
          $pickupStreet: String
          $pickupZipcode: String
          $pickupBuildingName: String
          $returnCity: String
          $returnState: String
          $returnStreet: String
          $returnZipcode: String
          $returnBuildingName: String
        ) {
          sendMessage(
            threadId: $threadId
            reservationId: $reservationId
            content: $content
            eventName: $eventName
            startDate: $startDate
            endDate: $endDate
            pickupTime: $pickupTime
            returnTime: $returnTime
            pickupCity: $pickupCity
            pickupState: $pickupState
            pickupStreet: $pickupStreet
            pickupZipcode: $pickupZipcode
            pickupBuildingName: $pickupBuildingName
            returnCity: $returnCity
            returnState: $returnState
            returnStreet: $returnStreet
            returnZipcode: $returnZipcode
            returnBuildingName: $returnBuildingName
          ) {
            id
            sentBy
            content
            eventName
            startDate
            endDate
            createdAt
          }
        }
      `;
      // Send Message
      const { data } = await client.mutate({
        mutation,
        variables: {
          threadId,
          content,
          eventName: threadType,
          startDate,
          endDate,
          reservationId,
          pickupTime,
          returnTime,
          pickupCity: pickupAddress.city,
          pickupState: pickupAddress.state,
          pickupStreet: pickupAddress.street,
          pickupZipcode: pickupAddress.zipcode,
          pickupBuildingName: pickupAddress.buildingName,
          returnCity: returnAddress.city,
          returnState: returnAddress.state,
          returnStreet: returnAddress.street,
          returnZipcode: returnAddress.zipcode,
          returnBuildingName: returnAddress.buildingName,
        },
        refetchQueries: [
          {
            query: AllThreadsQuery,
          },
        ],
      });
    } catch (error) {
      dispatch({
        type: SEND_MESSAGE_ERROR,
        payload: {
          error,
        },
      });
      return false;
    }

    return true;
  };
}



// WEBPACK FOOTER //
// ./src/actions/message/sendMessageAction.js